import { render, staticRenderFns } from "./powerMachineDetail.vue?vue&type=template&id=4d9b3bbc"
import script from "./powerMachineDetail.vue?vue&type=script&lang=js"
export * from "./powerMachineDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9b3bbc')) {
      api.createRecord('4d9b3bbc', component.options)
    } else {
      api.reload('4d9b3bbc', component.options)
    }
    module.hot.accept("./powerMachineDetail.vue?vue&type=template&id=4d9b3bbc", function () {
      api.rerender('4d9b3bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/pfi/powerMachineDetail.vue"
export default component.exports